import { gql } from '@apollo/client';

export const GET_ORGANISATION_PROGRAMME_USERS = gql`
  query AllOrganisationProgrammeUsers($id: ID!) {
    programmes: allOrganisationProgrammeUsers(id: $id) {
      owner {
        id
        firstName
        lastName
      }
      reporters {
        id
        assignee {
          id
          firstName
          lastName
        }
        organisation {
          id
          isFunder
          isInstitution
          isServiceProvider
          funder {
            id
            name
          }
          serviceProvider {
            id
            name
          }
          institution {
            id
            name
          }
        }
      }
      interventions {
        id
        serviceProviders {
          id
          name
        }
      }
    }
  }
`;
